import Logo from "assets/png/logoFooter.png";
import packageJson from "../../../package.json";
import { LogoImage, VersionContainer, VersionText } from "./styles.";

export function AppVersion() {
  return (
    <VersionContainer>
      <LogoImage src={Logo} alt="Legal Control" />
      <VersionText>
        Versão: {packageJson.version} Copyright © Legal Control. Todos os
        direitos reservados.
      </VersionText>
    </VersionContainer>
  );
}
